import CalendarAPI from '../../api/calendar.js'

export const calendar = {
    namespaced: true,
    state: {
        appointments: [],
        appointment: {},
        date: null,
        day: null,
        dayAppointments: [],
        timeline: [],
    },
    actions: {
        DAY: ({ commit }, day) => CalendarAPI.DAY(day.unix())
            .then(({ data: appointments }) => { commit("DAY", day); commit("DAY_APPOINTMENTS", appointments) }),

        WEEK: ({ commit }, data) => CalendarAPI.WEEK(data)
            .then(({ data: appointments }) => commit('APPOINTMENTS', appointments)),

        SAVE: ({ commit }, { appointment }) => CalendarAPI.SAVE(appointment)
            .then(({ data: appointments }) => commit('APPOINTMENTS', appointments)),

        DELETE: ({ dispatch }, { appointment, week }) => CalendarAPI.DELETE(appointment.type, appointment.id)
            .then(() => dispatch('WEEK', week)),

        TIMELINE: ({ commit }) => CalendarAPI.TIMELINE()
            .then(({ data: timeline }) => commit('TIMELINE', timeline)),
        PREV_TIMELINE: ({ commit, state }, day) => CalendarAPI.PREV_TIMELINE(day.unix())
            .then(({ data: timeline }) => commit('TIMELINE', timeline.concat(state.timeline))),
        NEXT_TIMELINE: ({ commit, state }, day) => CalendarAPI.NEXT_TIMELINE(day.unix())
            .then(({ data: timeline }) => commit('TIMELINE', state.timeline.concat(timeline)))
    },

    mutations: {
        DAY: (state, day) => state.day = day,
        DAY_APPOINTMENTS: (state, appointments) => state.dayAppointments = appointments,
        APPOINTMENTS: (state, appointments) => state.appointments = appointments,
        DATE: (state, date) => state.date = date,
        TIMELINE: (state, timeline) => state.timeline = timeline,
    },

}
